import { IInteressesResponse } from "./InteressesGateway";

export default class Interesse {
  constructor(readonly response: IInteressesResponse | undefined) {}
}
